import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  MenuItem,
  Switch,
  Backdrop,
  CircularProgress,
  Button,
  Divider,
  Chip,
  Stack
} from '@material-ui/core';
import { TextField } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Page from '../components/Page';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useRecoilState } from 'recoil';
import { snackbarAtom } from 'src/atoms/snackbar';
import axios from 'axios';
import * as dayjs from 'dayjs';

const loaderStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  height: '10%',
  width: '10%',
  display: 'grid',
  placeItems: 'center center'
};

const EditEmployee = () => {
  /* eslint-disable no-unused-vars */
  const [, setSnackbar] = useRecoilState(snackbarAtom);
  const navigate = useNavigate();
  const { id } = useParams();
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('lg'));
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const [addedBeneficiaries, setAddedBeneficiaries] = useState([]);
  const [oldBeneficiaries, setOldBeneficiaries] = useState([]);

  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(true);

  const [totalBalance, setTotalBalance] = useState(0);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState('');
  const [role, setRole] = useState('');
  const [office, setOffice] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [birthdate, setBirthdate] = useState(dayjs(new Date()));
  const [, setStartCeiling] = useState(dayjs(new Date()));
  const [, setEndCeiling] = useState(dayjs(new Date()));

  const [openBackdrop, setOpenBackdrop] = useState(false);

  // TODO: Make array for existing beneficiaries ( Cant delete);
  // and another one for new beneficiaries (Can delete)

  useEffect(() => {
    async function getData() {
      try {
        const { data, status } = await axios(`/employees/${id}`);
        if (status !== 200) {
          throw new Error("Couldn't get employee data");
        }
        setName(data.name);
        setBirthdate(dayjs(data.birthdate));
        setRole(data.role);
        setOffice(data.office);
        setGender(data.gender);
        setMaritalStatus(data.marital_status);
        setActive(data.active);
        setEmail(data.email);
        setTotalBalance(Number(data?.balance ?? 0).toFixed(2));
        setEmployeeId(data.employeeId);
        setStartCeiling(data?.ceiling_limit?.start_date ?? dayjs(new Date()));
        setEndCeiling(data?.ceiling_limit?.end_date ?? dayjs(new Date()));
        setOldBeneficiaries([...data.beneficiaries]);

        setLoading(false);
      } catch (err) {
        setSnackbar({ severity: 'error', open: true, message: err.message });
        console.log(err);
      }
    }
    getData().then();
    // eslint-disable-next-line
  }, []);
  const handleAddBeneficiaries = () => {
    setAddedBeneficiaries((x) => {
      return [
        ...x,
        {
          id: uuidv4(),
          dentalBalance: 0,
          glassesBalance: 0,
          name: '',
          gender: '',
          relationship: '',
          startBalance: dayjs(new Date()),
          endBalance: dayjs(new Date()),
          birthdate: dayjs(new Date())
        }
      ];
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    setOpenBackdrop(true);
    const employeeBody = {
      main_data: {
        name,
        email,
        gender,
        role,
        active,
        office,
        birthdate,
        balance: Number(totalBalance),
        marital_status: maritalStatus,
        last_edit: dayjs(new Date()),
        employeeId
      },
      ceiling_data: {
        total_balance: 0,
        start_date: dayjs(new Date()),
        end_date: dayjs(new Date())
      },
      balance_data: {
        total_glasses_balance: 0,
        total_dental_balance: 0,
        start_date: dayjs(new Date()),
        end_date: dayjs(new Date())
      }
    };
    const addedBeneficiariesBodies = addedBeneficiaries.map((x) => {
      return {
        name: x.name,
        birthdate: dayjs(x.birthdate),
        relationship: x.relationship,
        gender: x.gender,
        total_dental_balance: 0,
        total_glasses_balance: 0,
        start_date: dayjs(new Date()),
        end_date: dayjs(new Date()),
        last_edit: dayjs(new Date())
      };
    });
    const oldBeneficiariesBodies = oldBeneficiaries.map((ben) => {
      return {
        id: ben.id,
        main_data: {
          name: ben.name,
          gender: ben.gender,
          relationship: ben.relationship,
          birthdate: dayjs(ben.birthdate),
          last_edit: dayjs(new Date())
        },
        balance_data: {
          total_glasses_balance: 0,
          total_dental_balance: 0,
          start_date: dayjs(new Date()),
          end_date: dayjs(new Date())
        }
      };
    });
    try {
      const { data, status } = await axios({
        url: `/employees/${id}`,
        method: 'PATCH',
        data: employeeBody
      });
      if (status !== 200) {
        throw new Error("Couldn't make employee");
      }
      const partyId = data.id;

      for (let benBody of addedBeneficiariesBodies) {
        const { status } = await axios({
          url: `/employees/${partyId}/beneficiaries`,
          method: 'POST',
          data: benBody
        });
        if (status !== 201) {
          throw new Error("Couldn't create beneficiaries");
        }
      }

      for (let benBody of oldBeneficiariesBodies) {
        const benId = benBody.id;
        delete benBody.id;
        const { status } = await axios({
          url: `/beneficiaries/${benId}`,
          method: 'PATCH',
          data: benBody
        });
        if (status !== 200) {
          throw new Error("Couldn't create beneficiaries");
        }
      }

      navigate('../');
    } catch (err) {
      setSnackbar({ severity: 'error', open: true, message: err.message });
      console.log(err);
    } finally {
      setOpenBackdrop(false);
    }
  };

  if (loading) {
    return <CircularProgress style={loaderStyle} />;
  }
  return (
    <Page title="Update Employee | Incorta Care">
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <form
        onSubmit={handleSubmit}
        style={{
          paddingInline: match ? '16px' : '0'
        }}
      >
        <Stack
          direction="row"
          justifyContent={'space-between'}
          alignItems={'center'}
          fullWidth
          mb={4}
        >
          <Typography variant="h4">Update Employee</Typography>
          <FormControlLabel
            style={{
              width: '70%',
              position: 'relative',
              left: mobile ? '-16px' : '0'
            }}
            control={
              <Switch
                checked={active}
                onChange={async (e) => {
                  setActive(e.target.checked);
                }}
              />
            }
            label={active ? 'Active' : 'Disabled'}
          />
        </Stack>
        <Grid container direction="column">
          <Grid container alignItems="center" spacing={2}>
            {/* User specific data */}
            <Grid item md={3} xs={12}>
              <TextField
                label="Name"
                required
                variant="outlined"
                type="text"
                value={name}
                fullWidth
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Grid>
            <Grid item md={4} xs={12} my={{ xs: 2, md: 0 }}>
              <TextField
                label="Email"
                required
                variant="outlined"
                value={email}
                fullWidth
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                type="email"
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  // renderInput={(props) => <TextField {...props} fullWidth />}
                  slotProps={{ textField: { variant: 'outlined' } }}
                  label="Birthdate"
                  value={birthdate}
                  onChange={(newValue) => {
                    setBirthdate(dayjs(newValue));
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item md={2} xs={12}>
              <FormControl required fullWidth>
                <InputLabel id="gender-select-label">Gender</InputLabel>
                <Select
                  required
                  labelId="gender-select-label"
                  label="Gender"
                  id="gender-select"
                  value={gender}
                  variant="outlined"
                  fullWidth
                  style={{
                    borderRadius: '5px'
                  }}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <MenuItem value={'MALE'}>Male</MenuItem>
                  <MenuItem value={'FEMALE'}>Female</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container my={2} spacing={2}>
            <Grid item md={3} xs={12}>
              <TextField
                label="Balance (USD)"
                variant="outlined"
                required
                type="number"
                value={totalBalance}
                onChange={(e) => {
                  setTotalBalance(Number(e.target.value));
                }}
                fullWidth
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                label="Employee ID"
                variant="outlined"
                required
                type="text"
                value={employeeId}
                onChange={(e) => {
                  setEmployeeId(e.target.value);
                }}
                fullWidth
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <FormControl fullWidth required>
                <InputLabel id="marital-status-label">Marital Status</InputLabel>
                <Select
                  labelId="marital-status-label"
                  id="marital-status"
                  label="Marital Status"
                  sx={{
                    borderRadius: '5px'
                  }}
                  value={maritalStatus}
                  variant="outlined"
                  onChange={(e) => setMaritalStatus(e.target.value)}
                >
                  <MenuItem value={'SINGLE'}>Single</MenuItem>
                  <MenuItem value={'MARRIED'}>Married</MenuItem>
                  <MenuItem value={'DIVORCED'}>Divorced</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item md={2} xs={12}>
              <FormControl fullWidth required>
                <InputLabel id="role-select-label">Role</InputLabel>
                <Select
                  labelId="role-select-label"
                  id="role-select"
                  value={role}
                  label="Role"
                  sx={{
                    borderRadius: '5px'
                  }}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <MenuItem value={'EMPLOYEE'}>Employee</MenuItem>
                  <MenuItem value={'DOCTOR'}>Doctor</MenuItem>
                  <MenuItem value={'FINANCE'}>Finance</MenuItem>
                  <MenuItem value={'ADMIN'}>Admin</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={2} xs={12}>
              <FormControl fullWidth required>
                <InputLabel id="office-select-label">Office </InputLabel>
                <Select
                  labelId="office-select-label"
                  id="office-select"
                  label="Office"
                  value={office}
                  sx={{
                    borderRadius: '5px'
                  }}
                  required
                  onChange={(e) => setOffice(e.target.value)}
                >
                  <MenuItem value={'CAIRO'}>Cairo</MenuItem>
                  <MenuItem value={'ALEXANDRIA'}>Alexandria</MenuItem>
                  <MenuItem value={'UAE'}>UAE</MenuItem>
                  <MenuItem value={'KSA'}>KSA</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Divider>
            <Chip label="Beneficiaries" />
          </Divider>
          {/* Old Beneficiaries */}
          {oldBeneficiaries.map((ben) => {
            return (
              <Grid direction="column" container key={ben.id} mt={{ xs: 2 }}>
                <Grid item container>
                  <Grid item container md={5} xs={12}>
                    <Grid item md={5} xs={12}>
                      <TextField
                        label="Name"
                        required
                        variant="outlined"
                        type="text"
                        style={{ width: '100%' }}
                        value={oldBeneficiaries.find((x) => x.id === ben.id).name}
                        onChange={(e) => {
                          const newBeneficiaries = oldBeneficiaries.slice();
                          const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                          newBeneficiaries[idx].name = e.target.value;
                          setOldBeneficiaries([...newBeneficiaries]);
                        }}
                      />
                    </Grid>
                    <Grid item md={2} xs={'auto'}></Grid>
                    <Grid item md={5} xs={12}>
                      <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }} required>
                        <InputLabel id="demo-simple-select-filled-label">Gender </InputLabel>
                        <Select
                          labelId="demo-simple-select-filled-label"
                          id="demo-simple-select-filled"
                          value={oldBeneficiaries.find((x) => x.id === ben.id).gender}
                          onChange={(e) => {
                            const newBeneficiaries = oldBeneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].gender = e.target.value;
                            setOldBeneficiaries([...newBeneficiaries]);
                          }}
                        >
                          <MenuItem value={'MALE'}>Male</MenuItem>
                          <MenuItem value={'FEMALE'}>Female</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid item container md={2} xs={'auto'}></Grid>
                  <Grid item container md={5} xs={12}>
                    <Grid item md={5} xs={12}>
                      <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }} required>
                        <InputLabel id="demo-simple-select-filled-label">Relationship </InputLabel>
                        <Select
                          labelId="demo-simple-select-filled-label"
                          id="demo-simple-select-filled"
                          value={oldBeneficiaries.find((x) => x.id === ben.id).relationship}
                          onChange={(e) => {
                            const newBeneficiaries = oldBeneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].relationship = e.target.value;
                            setOldBeneficiaries([...newBeneficiaries]);
                          }}
                        >
                          <MenuItem value={'SPOUSE'}>Spouse</MenuItem>
                          <MenuItem value={'CHILD'}>Child</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={'auto'}></Grid>
                    <Grid item md={5} xs={12} mt={{ xs: 2 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          slotProps={{ textField: { variant: 'outlined' } }}
                          label="Birthdate"
                          value={dayjs(oldBeneficiaries.find((x) => x.id === ben.id).birthdate)}
                          onChange={(newValue) => {
                            const newBeneficiaries = oldBeneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].birthdate = newValue;
                            setOldBeneficiaries([...newBeneficiaries]);
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid mb={2}>
                  <Divider />
                </Grid>
              </Grid>
            );
          })}
          {/* New Beneficiaries */}
          {addedBeneficiaries.map((ben) => {
            return (
              <Grid direction="column" container key={ben.id} mt={{ xs: 2 }}>
                <Grid item container>
                  <Grid item container md={5} xs={12}>
                    <Grid item md={5} xs={12}>
                      <TextField
                        label="Name"
                        required
                        variant="outlined"
                        type="text"
                        style={{ width: '100%' }}
                        value={addedBeneficiaries.find((x) => x.id === ben.id).name}
                        onChange={(e) => {
                          const newBeneficiaries = addedBeneficiaries.slice();
                          const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                          newBeneficiaries[idx].name = e.target.value;
                          setAddedBeneficiaries([...newBeneficiaries]);
                        }}
                      />
                    </Grid>
                    <Grid item md={2} xs={'auto'}></Grid>
                    <Grid item md={5} xs={12}>
                      <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }} required>
                        <InputLabel id="demo-simple-select-filled-label">Gender </InputLabel>
                        <Select
                          labelId="demo-simple-select-filled-label"
                          id="demo-simple-select-filled"
                          value={addedBeneficiaries.find((x) => x.id === ben.id).gender}
                          onChange={(e) => {
                            const newBeneficiaries = addedBeneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].gender = e.target.value;
                            setAddedBeneficiaries([...newBeneficiaries]);
                          }}
                        >
                          <MenuItem value={'MALE'}>Male</MenuItem>
                          <MenuItem value={'FEMALE'}>Female</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid item container md={2} xs={'auto'}></Grid>
                  <Grid item container md={5} xs={12}>
                    <Grid item md={5} xs={12}>
                      <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }} required>
                        <InputLabel id="demo-simple-select-filled-label">Relationship </InputLabel>
                        <Select
                          labelId="demo-simple-select-filled-label"
                          id="demo-simple-select-filled"
                          value={addedBeneficiaries.find((x) => x.id === ben.id).relationship}
                          onChange={(e) => {
                            const newBeneficiaries = addedBeneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].relationship = e.target.value;
                            setAddedBeneficiaries([...newBeneficiaries]);
                          }}
                        >
                          <MenuItem value={'SPOUSE'}>Spouse</MenuItem>
                          <MenuItem value={'CHILD'}>Child</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={'auto'}></Grid>
                    <Grid item md={5} xs={12} mt={{ xs: 2 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          slotProps={{ textField: { variant: 'outlined' } }}
                          label="Birthdate"
                          value={dayjs(addedBeneficiaries.find((x) => x.id === ben.id).birthdate)}
                          onChange={(newValue) => {
                            const newBeneficiaries = addedBeneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].birthdate = newValue;
                            setAddedBeneficiaries([...newBeneficiaries]);
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>

                <Button
                  variant="outlined"
                  style={{ marginLeft: 'auto', marginRight: '0', marginBottom: '16px' }}
                  onClick={() => {
                    const newBeneficiaries = [...addedBeneficiaries].filter((x) => x.id !== ben.id);
                    setAddedBeneficiaries([...newBeneficiaries]);
                  }}
                  color="error"
                >
                  Delete Beneficiary
                </Button>
                <Grid mb={2}>
                  <Divider />
                </Grid>
              </Grid>
            );
          })}
          <Button
            variant="outlined"
            style={{ marginLeft: 'auto', marginRight: '0', marginTop: '10px' }}
            onClick={handleAddBeneficiaries}
          >
            Add Beneficiary
          </Button>

          <Grid mt={3}>
            <Button variant="contained" type="submit" style={{ width: '100%' }}>
              Update Employee
            </Button>
          </Grid>
        </Grid>
      </form>
    </Page>
  );
};
export default EditEmployee;
